import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseModalReturn } from '@percent/domain/giving'

export type UnpublishCampaignSuccessModalProps = Pick<UseModalReturn, 'isOpen' | 'closeModal'>

export function UnpublishCampaignSuccessModal({ isOpen, closeModal }: UnpublishCampaignSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={closeModal} aria-labelledby="unpublish-campaign-success">
      <AcknowledgeModal
        result="positive"
        title={t('workplace_giving.myCampaigns.actions.unpublishSuccessModal.title')}
        buttonText={t('workplace_giving.common.close')}
        handleClose={closeModal}
        buttonTestId="success-modal-btn"
      >
        {t('workplace_giving.myCampaigns.actions.unpublishSuccessModal.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
